module.exports = __webpack_public_path__ + "1.0.0-d5234419/img/offline-analytic-5.9744155b.svg";